import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Clock } from "@air/next-icons";
import { formatDuration } from "@air/utilities";
import { memo } from "react";
import { useSelector } from "react-redux";
import { CopyAllButton } from "~/components/AssetModalV2/Content/Panel/components/CopyAllButton";
import { JumpToDropdown } from "~/components/AssetModalV2/Content/Panel/components/JumpToDropdown";
import { centralizedClipDurationSelector, centralizedDisplayTitleSelector } from "~/store/centralizedClip/selectors";
export const ChapterVideoInfo = /*#__PURE__*/ memo((param)=>{
    let { chapters, seekToChapter, activeChapterIndex } = param;
    const clipTitle = useSelector(centralizedDisplayTitleSelector);
    const clipDuration = useSelector(centralizedClipDurationSelector);
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex flex-col gap-2.5 py-2",
        children: [
            /*#__PURE__*/ _jsx("h2", {
                className: "break-words text-16 font-semibold text-grey-12",
                children: clipTitle
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "flex flex-col gap-2",
                children: [
                    !!clipDuration && /*#__PURE__*/ _jsxs("div", {
                        className: "flex items-center gap-1 text-12 text-grey-11",
                        children: [
                            /*#__PURE__*/ _jsx(Clock, {
                                className: "size-4 text-grey-8"
                            }),
                            /*#__PURE__*/ _jsx("time", {
                                dateTime: formatDuration(clipDuration),
                                className: "font-feature-tnum",
                                children: formatDuration(clipDuration)
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex items-center gap-3",
                        children: [
                            /*#__PURE__*/ _jsx(JumpToDropdown, {
                                chapters: chapters,
                                seekToChapter: seekToChapter,
                                activeChapterIndex: activeChapterIndex
                            }),
                            /*#__PURE__*/ _jsx(CopyAllButton, {
                                chapters: chapters
                            })
                        ]
                    })
                ]
            })
        ]
    });
});
ChapterVideoInfo.displayName = "ChapterVideoInfo";
